import RegistrationScene from './RegistrationScene'
export default RegistrationScene